@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";
@use "ui/buttons/buttonStyles" as buttonStyles;

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  font-weight: 500;
  background: none;
  white-space: nowrap;
  transition: all 0.2s;

  @include buttonStyles.focus-ring;

  &:disabled {
    cursor: not-allowed;
  }
}

// Variants shared with IconButton — see packages/ui/buttons/_buttonStyles.scss
.primary {
  @include buttonStyles.variant-primary;
}

.secondary {
  @include buttonStyles.variant-secondary;
}

.tertiary {
  @include buttonStyles.variant-tertiary;
}

.quaternary {
  @include buttonStyles.variant-quaternary;
}

.progress {
  @include buttonStyles.variant-progress;
}

.completed {
  @include buttonStyles.variant-completed;
}

.white {
  @include buttonStyles.variant-white;
  cursor: pointer;
}

.black {
  @include buttonStyles.variant-black;
}

// Button-only variants (no IconButton equivalent).
.link {
  border: none;
  color: colorsOld.$sapphire;
  display: inline-block;
  font-weight: 400;

  &:hover:not(:disabled) {
    color: colorsOld.$sapphireDark;
  }

  &:disabled {
    color: colorsOld.$stoneLight;
  }
}

.remove {
  background-color: colorsOld.$white;
  color: colorsOld.$rubyDark;
  border: 1px solid colorsOld.$ruby;

  &:hover:not(:disabled) {
    color: colorsOld.$rubyDarkX1;
    border: 1px solid colorsOld.$rubyDark;
  }

  &:active {
    color: colorsOld.$rubyDarkX1;
    border: 2px solid colorsOld.$rubyDarkX1;
  }

  &:disabled {
    background-color: colorsOld.$stoneLightX3;
    color: colorsOld.$stoneLight;
    border: 1px solid colorsOld.$stoneLightX1;
  }
}

.green {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0px;
  background: transparent;
  border: none;
  font-family: "Px Grotesk Mono";
  font-weight: fontsOld.$black-weight;
  font-size: fontsOld.$medium;
  line-height: 110%;
  letter-spacing: -0.01em;
  color: colorsOld.$nanoGreen;
}

// sizes
.jumbo {
  border-radius: 6px;
  padding: 15px 21px;
  gap: 18px;
}

.large {
  border-radius: 4px;
  padding: 9px 15px;
  font-size: 14px;
  gap: 9px;
}

.medium {
  border-radius: 4px;
  padding: 9px 12px;
  font-size: 12px;
  gap: 6px;
}

.small {
  border-radius: 3px;
  padding: 6px 11px;
  font-size: 9px;
  text-transform: uppercase;
  gap: 6px;
}

.xsmall {
  border-radius: 3px;
  padding: 4px 8px;
  font-size: 9px;
  text-transform: uppercase;
  gap: 4px;
}

.none {
  font-size: inherit;
  padding: inherit;
  border: none;
}

.fullWidth {
  width: 100%;
  justify-content: center;
}

.noStyle {
  @include buttonStyles.variant-noStyle;
  font: inherit;
}
